import React from 'react';

const Tabs = ({ children }) => {
    // Note: styling is currently being set up by the Vue tabs.
    // See the applied CSS in Tabs.vue to learn more.
    return (
        <div className="tabs flex border-b border-amc-gray-400 text-sm mx-[10px] mt-[10px]">
            {children}
        </div>
    )

}

export default Tabs; 